import {en } from 'vuetify/locale';
import validations from "@/lang/en/validations";
import phoneCountryCodes from "@/lang/en/phone-country-codes";
import accountCategoryCodes from "@/lang/en/account-category-codes";
import changePassword from "@/lang/en/change-password";
import forgetPassword from "@/lang/en/forget-password";
import resetPassword from "@/lang/en/reset-password";
import userActivation from "@/lang/en/user-activation";
import regenQrcode from "@/lang/en/regen-qrcode";
import family from "@/lang/en/family";
import accountAssociation from "@/lang/en/account-association";
import loginInfo from "@/lang/en/login-info";
import otp from "@/lang/en/otp";
import buyerAccountActivation from "@/lang/en/buyer-account-activation";
import thirdPartyLink from "@/lang/en/third-party-link";
import emailForwarding from "@/lang/en/email-forwarding";
import campaignTeacherProfileUpdate from '@/lang/en/campaign-teacher-profile-update';

export default {
  $vuetify: en,
  title: "EdCity",
  forbidden: "You are not allowed to update this page. ",
  edcityHome: "EdCity Home Page",
  openMenu: "Expend Menu",
  closeMenu: "Collapse Menu",
  accountSetting: "Account Setting",
  logout: "Logout",
  submit: "Submit",
  press: "CLICK HERE",
  recaptchaLang: "en",  
  button: {
    submit: "Submit",
    reset: "Reset",
    close: "Close",
    goEdCity: "Visit EdCity website",
  },
  fatalError: {
    unauthorized: "Session has expired, please log in again and try.",
    unknown:
      "Something went wrong, please log in and try again later. If the problem persists, please contact us at support{'@'}edcity.hk.",
  },
  success: {
    basicProfileUpdated: "Your profile has been updated.",
    basicProfileUpdatedIncludeLoginEmail:
      "Your profile has been updated. A verification email has been sent to {email}. Please verify the change on or before {date}. Your new login email will be effective after the verification process.",
    basicProfileUpdatedIncludeContactEmail:
      "Your profile has been updated. A verification email has been sent to {email}. Please verify the change on or before {date}. Your new contact email will be effective after the verification process.",
    teacherProfileUpdated: "Your profile has been updated.",
    teacherProfileUpdatedIncludeTeacherEmail:
      "Your profile has been updated. A verification email has been sent to {email}. Please complete the verification process on or before {date}.",
    parentProfileUpdated: "Your profile has been updated.",
    organizationAccountListUpdated:
      "Organization Account List has been Updated.",
    organizationAccountListUploaded:
      "Organization Account List has been Uploaded.",
    passwordIsChanged: "Your password has been changed successfully.",
    accountActivated: "Activate account and update password successfully",
    loginQrcodeRegenerated: "Your login QR code has been regenerated.",
    loginInfoUpdated: "Your login info has been updated.",
    emailForwardingUpdated:"Your email forwarding settings have been updated.",
  },
  campaignTeacherProfileUpdate,
  validations,
  phoneCountryCodes,
  accountCategoryCodes,
  changePassword,
  forgetPassword,
  resetPassword,
  userActivation,
  regenQrcode,
  family,
  accountAssociation,
  loginInfo,
  otp,
  buyerAccountActivation,
  thirdPartyLink,
  emailForwarding,
  profile: {
    menuList: {
      selfService: "Self-Service",
      emailForwarding: "Set up Email Forwarding Function",
      myRecords: "My Records",
      subscription: "Subscription",
      edcityHomepage: "Go to EdCity homepage",
      editProfile: "Add / Update My Profile",
      basicProfile: "Basic Information",
      teacherProfile: "'Be a Teacher' Information",
      parentProfile: "'Be a Parent' Information",
      familyProfile: "Family Link",
      password: "Password",
      changePassword: "Change Password",
      regenQrcode: "Regenerate QR Code",
      accountAssociation: "Account Association",
      loginInfo: "Login information",
    },
    basic: {
      heading: "Update My Profile",
      loginEmail: "Login Email",
      loginEmailTooltip:
        "A verification email will be sent to your new email address. Please click on the link inside to verify the change. Kindly make the request again in case you do not receive the email or have other changes.",
      accountInfoHeading: "Account Information",
      cityId: "Login ID",
      accountCategory: "Account Category",
      personalInfoHeading: "Personal Info",
      title: "Title",
      titles: {
        mr: "Mr",
        mrs: "Mrs",
        miss: "Miss",
        ms: "Ms",
      },
      chiSurname: "Surname (Chinese)",
      chiGivenName: "Given Names (Chinese)",
      engSurname: "Surname (English)",
      engGivenName: "Given Names (English)",
      displayName: "Nickname",
      displayNameTooltip: "Can be changed at any time.",
      generateDisplayName: "Generate Nickname",
      contactEmail: "Contact Email",
      mobileCountryCode: "Country or Region",
      mobilePhoneNum: "Mobile Phone Number",
      subscriptionHeading: "Subscribe to EdCity’s Newsletters",
      subscription:
        "Please select the newsletters and activity updates that you would like to receive: ",
      subscriptions: {
        edPost: "EdPost",
        teacherInfo: "Teacher News",
        parentInfo: "Parent News",
        studentInfo: "Student News",
        DoNotCall: "I do not want to receive any information from EdCity.",
      },
      thirdPartyHeading: "Link your EdCity account with a third-party account",
      thirdPartyHeadingMember:
        "Link your EdCity Member account with a third-party account",
      thirdPartyAccount:
        "You may login to EdCity website with available third-party account options below.",
      connectInstruction:
        "Please click the icon(s) to link / unlink a third-party account.",
      loginEmailUnaccepted: "@:{'registration.loginEmailUnaccepted}",
      loginEmailInUse:
        "This email address has already been used. Please use another email address.",
      chiSurnameBadword:
        "Surname (Chinese) cannot include indecent language. Please use another name.",
      chiGivenNameBadword:
        "Given Names (Chinese) cannot include indecent language. Please use another name.",
      engSurnameBadword:
        "Surname (English) cannot include indecent language. Please use another name.",
      engGivenNameBadword:
        "Given Names (English) cannot include indecent language. Please use another name.",
      displayNameBadword:
        "Nickname cannot include indecent language. Please use another name.",
      displayNameInUse:
        "This nickname has already been taken, please try another name.",
      contactEmailRequired: "Please input your email address.",
      loginEmailPending:
        "This email address has already been used and is pending to be activated.",
      identityVerification: "Identity Verification",
      verificationMethod: "Verification Method",
      iamsmart: "iAM Smart",
      verificationDate: "Verification Date",
      mobileVerification: {
        no: "Not Yet Verified",
        yes: "Verified",
        verifyButton: "Verify",
        reVerifyButton: "Change Number",
        sendSMSButton: "Send Code",
        backToSendButton: "Back To Send",
        backToProfileButton: "Back To Profile",
        codeLabel: "Input the verification code",
        heading: "Verify Mobile Phone Number",
        code: "Verification Code",
        info: "",
        verifySuccess: "Verify Successfully.",
        countdown: "Validity time of verification code: ",
        codeExpired:
          "The verification code has expired. Please go back and try again. ",
        validations: {
          codeInvalid: "The code is invalid",
        },
        errors: {
          sendFail: "Cannot send, please try again.",
        },
      },

      upgradeStudentMemberPopUp: {
        title: "Upgrade to Student Membership",
        intro: {
          desc: "School-based accounts can now be upgraded to memberships, granting you complete control over your account. With this upgrade, you can manage your user profile and access your activity history at EdCity, regardless of the class or school you attend. ",
          tos: "Terms of Service",
          acceptTos:
            "I certify that I have read and agree to the {privacy}, {copyright}, {disclaimer} and {tac} of Hong Kong Education City.",
          privacyStatement: "Privacy Statement",
          privateStatementUrl: "https://www.edcity.hk/home/en/dataprivacy",
          copyright: "Copyright and Intellectual Property Rights",
          copyrightUrl: "https://www.edcity.hk/notices/tc_english.php#s2",
          disclaimer: "Disclaimer",
          disclaimerUrl: "https://www.edcity.hk/notices/tc_english.php#s3",
          tac: "Terms of Service",
          tacUrl: "https://www.edcity.hk/notices/tc_english.php#s4",
          upgradeButton: "Upgrade",
          skipButton: "Skip",
        },
        inputEmail: {
          stepTitle: "Personal Email",
          title: "Personal Email Verification",
          desc: "Upgrading to student membership makes it easier to manage your student account. In addition to the login name or school email created for you by the school, you can use your personal email for login purposes. Please enter your personal email and verify it.",
          email: "Personal Email",
          sendButton: "Send Verification Code",
        },
        verifyEmail: {
          stepTitle: "Verify Email",
          title: "Enter Verification Code",
          desc: "Please enter the verification code sent to your personal email. Once entered, please click the button below to verify your email.",
          button: "Verify",
          code: "Verification Code",
          verifySuccess: "Verify Successfully.",
          countdown: "Validity time of verification code: ",
          codeExpired:
            "The verification code has expired. Please go back and try again. ",
        },
        verifiedEmail: {
          title: "Verified!",
          desc: "Your email has been verified. Now you can proceed to subscribe to EdCity News.",
          button: "Next",
        },
        subscribeNews: {
          stepTitle: "Subscribe to EdCity’s Newsletters",
          desc: "Upon upgrading to student membership, your subscribed newsletters will be transferred from your student account to your personal email. Please confirm or change your selection.",
          subscribeButton: "Confirm",
          cancelButton: "Cancel",
        },
        linkEmail: {
          stepTitle: "Link Personal Email",
          createDesc:
            "To use your personal email as a login for your student account, please enter a new password below. Please note that the login information created for you by the school administrator will still exist and will not be changed.",
          updateDesc:
            "The personal email you entered already exists. Are you sure you want to link it to this student account (login name: {cityId})? ",
          linkButton: "Link",
          cancelButton: "Cancel",
        },
        finish: {
          stepTitle: "Finish",
          title: "All Set!",
          desc: "Congratulations! You have successfully upgraded to student membership.",
          finishButton: "Finish",
        },
      },
      upgradePopupStepTitle: {
        title: "Apply to Upgrade the Membership",
        emailVer: "Step 1 - Email Verification",
        phoneVer: "Step 2 -Phone Verification",
        info: "Step 3 - Update User Information",
        finish: "All Set!",
        next: "next",
        upgrade: "Upgrade",
        lastStep: "Back",
        stepper_email: "Login Email",
        stepper_sms: "Phone",
        stepper_info: "Info Update",
        stepper_done: "All Set!",
      },
      upgradePopupWelcome: {
        title: "Apply to Upgrade the Membership",
        desc: "Verify your identity to upgrade to a member and unlock all features. This will only take about 5 minutes.",
        requirement: "What you will need:",
        requirement1: "Valid email address",
        requirement2: "Phone number that is reachable via SMS.",
        requirement3:
          "Personal information, including gender, year of birth and address.",
        upgradeButton: "Upgrade",
        skipButton: "Skip",
        errorMsg: "Something went wrong, try again later.",
      },
      emailVerPopup: {
        title: "Verify Email Address",
        desc: "Click the button below to send a verification code via email.",
        sendButton: "Send Code",
        email: "Email Address",
        emailInvalid: "Invalid email address",
        emailRequired: "Email address is required",
      },
      emailCodeVerPopup: {
        title: "Verify Email Address",
        desc: "A 6-digit verification code has been sent your email address. When you receive the code, enter it below.",
        button: "verify",
      },
      emailVerifiedPopup: {
        title: "Verified!",
        desc: "Your email address has been successfully verified. You can now proceed to verify your phone number. ",
      },
      mobileVerifiedPopup: {
        title: "Verified!",
        desc: "Your phone number has been successfully verified. You can now proceed to update user information.",
      },
      verPopupFinish: {
        title: "All Set!",
        desc: "Thank you for verifying your identity. You now have unrestricted access to all features.",
        button: "Finish",
      },
      verPopupInfo: {
        title: "User Information",
        gender: "Gender",
        genderMale: "Male",
        genderFemale: "Female",
        yearOfBirth: "Year of Birth",
        selfClaimTitle: "Identity",
        selfClaimTeacher: "Teacher",
        selfClaimStudent: "Student",
        selfClaimParent: "Parent",
        selfClaimRequired: "Please Select Role",
        genderRequired: "Please Select Gender",
        birthRequired: "Please Select Birth Year",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        region: "Region",
        district: "District",
        button: "Update",
        regionHK: "Hong Kong",
        regionCN: "China",
        regionMU: "Macau",
        regionOR: "Others",
        districtHK: {
          yuenLong: "Yuen Long",
          yauTsimMong: "Yau Tsim Mong",
          wongTaiSin: "Wong Tai Sin",
          wanChai: "Wan Chai",
          tuenMun: "Tuen Mun",
          tsuenWan: "Tsuen Wan",
          taiPo: "Tai Po",
          southern: "Southern",
          shamShuiPo: "Sham Shui Po",
          shaTin: "Sha Tin",
          saiKung: "Sai Kung",
          north: "North",
          kwunTong: "Kwun Tong",
          kwaiTsing: "Kwai Tsing",
          kowloonCity: "Kowloon City",
          islands: "Islands",
          eastern: "Eastern",
          centralAndWestern: "Central and Western",
        },
      },
      address: {
        heading: "Address",
        region: "Region",
        district: "District",
        chiAddressLine1: "Address Line 1  (Chinese)",
        chiAddressLine2: "Address Line 2 (Chinese)",
        engAddressLine1: "Address Line 1  (English)",
        engAddressLine2: "Address Line 2 (English)",
      },
      studentAccountInfo: {
        heading: "School Information",
        info: "(Student Information, Cannot Be Modified)",
        schoolName: "School",
        chiFullName: "Chinese Name",
        engFullName: "English Name",
        class: "Class(Class No.)",
        schoolEmail: "School Email",
        upgradeButton: {
          studentMember: "Upgrade to Student Membership",
          fullMember: "Upgrade Membership",
        },
      },
    },
    teacher: {
      heading: "Update Teacher Profile",
      teacherType: "Please select teacher type:",
      teacherTypes: {
        registered:
          "Registered Teacher{'@'}EDB (verification with e-Services Account)",
        preService: "Pre-Service Teacher",
        prePrimary: "Pre-Primary Teacher",
        universityTeacher: "University Teaching Staff",
        retired: "Retired Teacher",
        others: "Other Types of Teacher",
        required: "Please select teacher type.",
        invalid: "Invalid teacher type",
      },
      teacherTypeHints: {
        registered:
          "A verification email will be sent to the below account. Please login to e-Services Portal (https://eservices.edb.gov.hk/) to check the email and complete the verification process.",
        preService:
          "A verification email will be sent to the below account. Please check the email to complete the process.",
        universityTeacher:
          "A verification email will be sent to the below account. Please check the email to complete the process.",
      },
      eservicesUserName: "e-Services Username",
      eservicesUserNameRetype: "Retype e-Services Username",
      preServiceInstitution: "Your institution",
      teacherInstitution: {
        required: "Please select teacher institution.",
        invalid: "Invalid teacher institution",
      },
      teacherEmail: {
        required: "Please provide teacher email.",
        invalid: "Invalid email address",
        duplicated:
          "The email address has already existed. Please update again with another email address.",
        improper: "This email address is unaccepted or improper.",
      },
      preServiceUserName: "School Username",
      preServiceUserNameRetype: "Retype School Username",
      preServiceEmailDomain: {
        required: "Please provide school email domain.",
      },
      universityTeacherInstitution: "Your institution",
      universityTeacherUserName: "School Username",
      universityTeacherUserNameRetype: "Retype School Username",
      universityTeacherEmailDomain: {
        required: "Please provide school email domain.",
      },
      schoolInfoHeading:
        "School Information (Uploaded by School Administrator)",
      school: "School",
      schoolName: "{name} (EdCity School code: {code})",
      schoolEmail: "School Email",
      schoolEmailDomain: "School Email Address Domain",
       schoolStaffInfo: {
        contactPerson:{
           title: "Show School Administrator Information",
           heading: "Show School Administrator Information",
           staffName: "School Administrator Name",
           description: "To update School Email, please contact your School Administrator:",
        },
        buyer:{ 
          title: "Show School Buyer Information",
          heading: "Show School Buyer Information",
          staffName: "School Buyer Name",
          description: "To purchase school-based services, please contact your School Buyer:",
        },       
        schoolName:  "School Name",
        staffContactCountryCode: "Country or Region (Contact Telephone)",
        staffContactNumber: "Contact Telephone",
        staffContactEmail: "Contact Email",
        closeWindow: "Close",
        invalid:  "The function is limited to School-based Teacher only. Please switch to an eligible account type and attempt again",
      },
      teachingSubjectHeading: "Major Teaching Subjects",
      subjectList: {
        invalid: "Invalid data format, require array",
      },
      teachingLevel: "Teaching Level",
      teachingLevels: {
        prePrimary: "Pre-primary",
        primary: "Primary",
        secondary: "Secondary",
        tertiary: "Tertiary",
        special: "Special Education",
      },
      curriculumList: {
        basicEdu: "Special Education (Basic Education Curriculum)",
        seniorSec: "Special Education (Senior Secondary Curriculum)",
        basicEduId: "Special Education (Basic Education Curriculum - ID)",
        seniorSecId: "Special Education (Senior Secondary Curriculum - ID)",
        gsPri: "General Studies for Primary Schools",     
        langPri: "Language Education",   
        langSec: "Language Education",        
        sciSec: "Science Education",
        techSec: "Technology Education",
        psheSec: "Personal, Social and Humanities Education", 
      },
      teachingSubject: "Please select below:",
      dutyHeading: "Major Duties",
      dutyRemarkHeading: "Other Duties",
      interestAreaHeading: "Areas of Interest",
      interestAreaList: {
        invalid: "Invalid data format, require array",
      },
      dutyList: {
        invalid: "Invalid data format, require array",
      },
      dutyRemark: {
        required: "Please provide other major duties.",
        invalid: "Invalid data format, require string",
      },
      o365AccountHeading: "Microsoft Office 365 Education account",
      o365AccountDescription:
        "Riding on the comprehensive EdCity membership system and the multifunctional Microsoft Office 365 Education (Office 365 A1) account, teachers are supported to implement remote teaching easily, as well as share experiences and collaborate with the peers to co-build a professional teaching community.",
      applyO365AccountInstruction:
        "Apply for free Microsoft Office 365 Education account? Please {action}",
      o365LoginName: "Login Name",
      useO365Instruction:
        "Please log in to Microsoft Office 365 {link} to enjoy the services.",
      authType: {
        invalid: "Invalid user auth type",
      },
      eservicesUserNameUnmatch:
        "The @:{'profile.teacher.eservicesUserName'} does not match with the confirmation one. Please try again.",

      preServiceUserNameUnmatch:
        "The @:{'profile.teacher.preServiceUserName'} does not match with the confirmation one. Please try again.",

      universityTeacherUserNameUnmatch:
        "The @:{'profile.teacher.universityTeacherUserName'} does not match with the confirmation one. Please try again.",
    },
    parent: {
      heading: "Update Parent Profile",
      interestAreaHeading: "Areas of Interest",
    },
  },
  edbRegistration: {
    heading: "Register for EdCity Member Account",
    loginEmailUserName: "EDB Email",
    reconfirmLoginEmailUserName: "Re-confirm EDB email",
    step1: "Provide Email Address from EDB",
    step2: "Receive Email Notifications",
    step3: "Ready to Use EdCity Service",
    description:
      "Welcome to Hong Kong Education City (EdCity)! As the strategic partner of Education Bureau, we hope you can better understand an array of learning and teaching resources and services we provide to schools, so as to facilitate further collaborations and development. Therefore, we set up a simple mechanism for you to activate your member account with EdCity. <br> <br> You can simply fill in your email address with the Education Bureau, and you will be notified of your member ID number and account activation link via that registered email account<font color='#FF0000'>*</font>. Your member identity will be equivalent to a school-based teacher account. You can use the account to gain access to EdCity’s school-based services.",
    reminder:
      "<small><font color='#FF0000'>*</font>If your EDB email address becomes invalid, your account with EdCity will be terminated automatically.</small>",
    contact:
      "Should you have any enquiries, please email us at {supportEmail}.",
    supportEmailLink: "mailto: support{'@'}edcity.hk",
    supportEmail: "support{'@'}edcity.hk",
    registerButton: "Register for EdCity Account",
    submitCreate: "Submit Registration",
    completed:
      "Welcome to EdCity! Your login email is {loginEmail}. An activation email has been sent to {emailSentTo}. ",
    loginEmailUnaccepted:
      "This email domain is not accepted. Please use another email.",
    loginEmailInUse:
      "An EdCity account already exists with the email address. Please register again with another email address.",
    loginEmailPending:
      "This email address has already been used and is pending to be activated.",
  },
  registration: {
    heading: "Create Individual User Account",
    accountAssociationDesc:
      "Auto associate with your student account ( Login ID: {linkedLoginId} ).",
    notAllowLinkUser: "Sorry. This link is not valid.",
    loginEmail: "Login Email",
    loginEmailHint: "This will be used to sign-in to your account",
    surname: "Surname",
    givenName: "Given Names",
    tos: "Terms of Service",
    acceptTos:
      "I certify that I have read and agree to the {privacy}, {copyright}, {disclaimer} and {tac} of Hong Kong Education City.",
    privacyStatement: "Privacy Statement",
    privateStatementUrl: "https://www.edcity.hk/home/en/dataprivacy",
    copyright: "Copyright and Intellectual Property Rights",
    copyrightUrl: "https://www.edcity.hk/notices/tc_english.php#s2",
    disclaimer: "Disclaimer",
    disclaimerUrl: "https://www.edcity.hk/notices/tc_english.php#s3",
    tac: "Terms of Service",
    tacUrl: "https://www.edcity.hk/notices/tc_english.php#s4",
    submitCreate: "Create Account",
    completed:
      "Welcome to EdCity! Your login email is {loginEmail}. An activation email has been sent to {emailSentTo}. Please activate your account on or before {validThru}, or else you should register again.",
    loginEmailUnaccepted:
      "This email domain is not accepted. Please use another email.",
    loginEmailInUse:
      "An EdCity account already exists with the email address. Please register again with another email address.",
    loginEmailPending:
      "This email address has already been used and is pending to be activated.",
    alreadyVerifiedAsTeacher:
      "An EdCity Individual Teacher account already exists with the email address. Please register again with another email address. ",
    surnameBadword:
      "Surname cannot include indecent language. Please use a different name.",
    givenNameBadword:
      "Given Names cannot include indecent language. Please use a different name.",
    birth: "Year of Birth",
    gender: {
      label: "Gender",
      female: "Female",
      male: "Male",
    },
    selfClaimRolesList: {
      heading: "Your roles:",
      label: "Roles",
      TEACHER: "Teacher",
      STUDENT: "Student",
      PARENT: "Parent",
    },
    closeBtn: "Close",
    manualCloseMsg: "Please close this window. After successfully activating your EdCity account, please return to the application and manually click the \"Log in\" button to complete the login process.",
  },
  teacherAuthVerify: {
    heading: "EdCity Teacher Account Verification",
    success: "Your teacher account has been verified successfully.",
    fail: "Error!",
    required: "Please provide verification link.",
    invalid: "This is not a valid teacher verification page!",
    verified: "The link has been verified.",
    expired: "The link has expired.",
    teacherEmail: {
      duplicated:
        "The email address has already existed. Please update again with another email address.",
    },
    user: {
      invalid: "This is not a valid user account.",
    },
  },
  loginEmailVerification: {
    heading: "Email Address as Login ID Confirmation",
    submit: "Confirm",
    success: "Your login ID is successfully changed to {email}",
    fail: "Error!",
    invalid: "This is not a valid email confirmation page!",
    verified: "The link has been verified.",
    expired: "The link has expired.",
    duplicated:
      "This email address is already being used as a login email for another EdCity account. Please go back and try again with a different email address.",
  },
  contactEmailVerification: {
    heading: "Contact Email Address Change Confirmation",
    submit: "Confirm",
    success: "Your Contact Email is successfully changed to {email}",
    fail: "Error!",
    invalid: "This is not a valid email confirmation page!",
    verified: "The link has been verified.",
    expired: "The link has expired.",
  },
  emailSubscriptionVerification: {
    heading: "Subscription Change Confirmation",
    success: "Your subscription is successfully changed to:",
    fail: "Error!",
    invalid: "This is not a valid email confirmation page!",
    verified: "The link has been verified.",
    expired: "The link has expired.",
  },
  organizationAccountList: {
    itemsPerPage: {
      0: "Show",
      1: "rows per page",
    },
    teacher_type: {
      PRE_SERVICE: "Student",
      UNIVERSITY_TEACHER: "Staff",
    },
    readOnly: "Read-Only Mode",
    emailAddress: "Email Address",
    chFullName: "Chinese Name",
    enFullName: "English Name",
    remark: "Remark",
    updatedAt: "Updated At",
    updatedBy: "Updated By",
    actions: "Action",
    add: "Add",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    confirm: "Are you sure you want to delete this record?",
    search: "Search",
    group: "Select Group:",
    itemsPerPageText: "Show {0} rows per page:",
    pageText: "{0}-{1} of {2}",
    import: "Import",
    editItem: {
      emailAddress: {
        label: "Email Address",
        validation: {
          maxLength: "Max length is exceed",
          duplicated: "Email address is already used",
          improper: "Invalid email address",
        },
      },
      chFullName: {
        label: "Chinese Name",
        validation: {
          maxLength: "Max length is exceed",
        },
      },
      enFullName: {
        label: "English Name",
        validation: {
          maxLength: "Max length is exceed",
        },
      },
      remark: {
        label: "Remark",
        validation: {
          maxLength: "Max length is exceed",
        },
      },
      updatedAt: {
        label: "Updated At",
      },
      updatedBy: {
        label: "Updated By",
      },
    },
    importFile: {
      label: "Click here to select a .xlsx file",
      validation: {
        file: {
          required: "Import file is required",
          invalid: "Import file is invalid",
          exceedMax: "Import file cannot contain more than 1,000 records",
        },
        emailAddress: {
          invalid: "Invalid email address in import file",
          improper: "Improper email address in import file",
          duplicated: "Duplicated email address in import file",
          exceedMax:
            "Email address in import file must contain 1 to 254 characters",
        },
        chFullName: {
          invalid: "Invalid Chinese Name format in import file",
          exceedMax:
            "Chinese Name in import file must contain 1 to 100 Chinese characters",
        },
        enFullName: {
          invalid: "Invalid English Name format in import file",
          exceedMax:
            "English Name in import file must contain 1 to 100 characters",
        },
        remark: {
          invalid: "Invalid remark format in import file",
          exceedMax: "Remark in import file must contain 1 to 100 characters",
        },
      },
      downloadTemplate: "Download the 'XLS/XLSX' template",
    },
    export: "Export",
    emailAddressUnaccepted: "Invalid email domain.",
  },
  googleSSO: {
    fail: "Error!",
    close: "Close",
    heading:
      "Export of Google Account(s) for EdCity Single Sign-On (SSO) Registration",
    clientId: "Client ID",
    domain: "Domain",
    getUsers: "Get Users",
    exportToExcel: "Download to Excel file",
  },
  subscription: {
    label: {
      email: "Email Address",
      confirmEmail: "Re-enter your email address for comfirmation",
    },
    button: {
      confirm: "Submit & Confirm",
      reset: "Reset",
      close: "Close",
      backToHome: "Back to homepage",
    },
    validations: {
      emailIsEmpty: "Please enter your email address.",
      emailFormatWrong: "Invalid email address format. Please try again.",
      serviceIsEmpty:
        "Please select the newsletters and activity updates that you would like to receive.",
      confirmEmailIsEmpty: "Please enter valid email address format.",
      confirmEmailIsNotSame:
        "The email address you entered does not match. Please try again.",
    },
    text: {
      emailIntro:
        "Enter your email address to receive EdCity’s news<span class='text-red'>*</span>",
      useDataHeading: "Use of personal data in direct marketing",
      emailConfirm: "You will receive a confirmation of your subscription by email on the same day.",
      emailVerification: "A verification email has been sent to your email address. Please confirm your subscription by clicking the link in the email.",
      useDataContent:
        "<p>EdCity intends to use your personal data, i.e. name, telephone number and email address, to contact you and email you newsletter and information about the latest education related news, special offers, activities, services and products of EdCity and its co-organisers / supporting organisations. Such direct marketing will strictly comply with the privacy policy of EdCity. You can opt not to receive such emails anytime. EdCity may not use your personal data unless it has received your consent.</p><p>I wish to receive newsletter and any information about the latest education related news, special offers, activities, services and products of EdCity and its co-organisers / supporting organisations.</p>",
      successHeading: "Thank you for signing up for EdCity’s news!",
      successInfo:
        "You will receive the following newsletters and activity updates:",
    },
  },
  region: {
    HONGKONG: "Hong Kong",
    MACAU: "Macau",
    CHINA: "China",
    OTHER: "Others",
  },
  districtHK: {
    YUENLONG: "Yuen Long",
    YAUTSIMMONG: "Yau Tsim Mong",
    WONGTAISIN: "Wong Tai Sin",
    WANCHAI: "Wan Chai",
    TUENMUN: "Tuen Mun",
    TSUENWAN: "Tsuen Wan",
    TAIPO: "Tai Po",
    SOUTHERN: "Southern",
    SHAMSHUIPO: "Sham Shui Po",
    SHATIN: "Sha Tin",
    SAIKUNG: "Sai Kung",
    NORTH: "North",
    KWUNTONG: "Kwun Tong",
    KWAITSING: "Kwai Tsing",
    KOWLOONCITY: "Kowloon City",
    ISLANDS: "Islands",
    EASTERN: "Eastern",
    CENTRALANDWESTERN: "Central and Western",
  },
};